<template>

<div class="recommendation">

	<com-headmain :simple="true" />

	<div class="recommendation-content">

		<template v-if="!currentAlert">

			<router-link :to="{name: 'Home'}" class="section-exit" v-if="!window.is.mobile"></router-link>

			<com-head :name="recommendation.name" />

			<com-summary v-if="recommendation.summary.enabled" :recommendation="recommendation" />

			<div class="recommendation-saved" v-if="is.saved">The patient profile has been successfully saved, you may re-open it at a later date.</div>

			<com-inputs :recommendation="recommendation" />

			<com-treatment :recommendation="recommendation" />

			<com-reason v-if="recommendation.reason.enabled" :recommendation="recommendation" />

			<com-information v-if="recommendation.information.enabled" :recommendation="recommendation" />

			<com-nextsteps :recommendation="recommendation" v-on:action="onActionClick" />

			<com-foot v-if="hasAid && selected && !hasActions" :custom="true" v-on:next="onNextClick" />

			<com-bridge-complete v-if="bridge.step === 'bridge-done'" v-on:done="onBridgeDone" />

		</template>

		<portal to="modal">

			<com-supplementary v-if="bridge.step === 'questions'" :trigger="bridge.trigger" v-on:complete="onSupplementaryComplete" v-on:cancel="onSupplementaryCancel" />

			<com-referral v-if="bridge.step === 'referral'" :recommendation="recommendation" v-on:close="onBridgeDone" v-on:used="onReferralUsed" />

			<com-print v-if="bridge.step === 'print-done'" :recommendation="recommendation" v-on:close="onBridgeDone" />

		</portal>

		<com-alert :alert="dynamicAlert" v-if="currentAlert === true" />
	
	</div>
	
</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comHead from './recommendation/Head'
import comInputs from './recommendation/Inputs'
import comTreatment from './recommendation/Treatment'
import comSummary from './recommendation/Summary'
import comReason from './recommendation/Reason'
import comInformation from './recommendation/Information'
import comNextsteps from './recommendation/NextSteps'
import comSupplementary from './recommendation/SupplementaryQuestions'
import comBridgeComplete from './recommendation/BridgeComplete'
import comReferral from './recommendation/ReferralLetter'
import comPrint from './recommendation/PrintSummary'
import comFoot from './../common/section/Foot'
import comAlert from './../common/section/Alert'

export default {

	components: {

		'com-headmain': comHeadMain,
		'com-head': comHead,
		'com-summary': comSummary,
		'com-reason': comReason,
		'com-inputs': comInputs,
		'com-treatment': comTreatment,
		'com-information': comInformation,
		'com-nextsteps': comNextsteps,
		'com-supplementary': comSupplementary,
		'com-bridge-complete': comBridgeComplete,
		'com-referral': comReferral,
		'com-print': comPrint,
		'com-foot': comFoot,
		'com-alert': comAlert

	},

	data: function() {

		return {
			is: {
				saved: false
			},
			bridge: {
				step: null,
				trigger: null
			}
		}

	},

	computed: {

		selected: function() {

			var selected = this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable)

			return (selected) ? selected.length : 0

		},

		hasNone: function() {

			var selected = this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable)

			return this.$_.contains(selected, 0)

		},

		dynamicAlert: function() {

			return this.$store.getters['session/alerts/dynamic']

		},

		recommendation: function() {

			return this.$store.getters['data/decision/recommendations'][this.$store.getters['session/recommendation']]

		},

		hasActions: function() {

			return this.$store.getters['data/bridge/actions'].length > 0

		}

	},

	created: function() {

		if (this.$store.getters['session/values'][this.$store.getters['data/setup/profile/store']]) {

			var profiles = JSON.parse(this.$cookies.getItem('copd_profiles'))
			var id = this.$store.getters['session/profile']

			if (id === true) id = this.$moment().unix()

			profiles[id] = this.$store.getters['session/values']

			this.$cookies.setItem('copd_profiles', JSON.stringify(profiles))

			this.$store.commit('session/profile', id)

			this.is.saved = true

		}

		this.$store.commit('session/values/override', {
			id: this.$store.getters['data/setup'].treatments.variable,
			value: []
		})

	},

	methods: {

		onActionClick: function(action) {

			var type = action.type

			if (type === this.$constants.action.type.bridge) {

				this.setBridgeMode(true)
				this.bridge.trigger = 'bridge'
				this.bridge.step = 'questions'
				this.$store.commit('session/bridge/active', action)
				this.$store.commit('session/bridge/step', 'questions')

			} else if (type === this.$constants.action.type.navigate) {

				this.$api.request('bridge/save', {
					values: this.$store.getters['session/values'],
					answers: {},
					recommendation: this.$store.getters['session/recommendation']
				}).then(function(response) {

					this.$store.commit('session/bridge/completed', action.id)
					window.open('https://ifrap2p.codelish.com?code=' + response.code, '_blank')

				}.bind(this))

			} else if (type === this.$constants.action.type.print) {

				this.setBridgeMode(false)
				this.bridge.trigger = 'print'
				this.bridge.step = 'questions'
				this.$store.commit('session/bridge/active', action)
				this.$store.commit('session/bridge/step', 'questions')

			} else if (type === this.$constants.action.type.referral) {

				this.$store.commit('session/bridge/active', action)
				this.bridge.step = 'referral'

			} else if (type === this.$constants.action.type.exit) {

				this.$store.commit('session/alerts/dynamic', {
					type: this.$constants.alert.type.warning,
					name: 'Confirm',
					message: action.confirm || '<p>Please confirm that you wish to exit the Osteoporosis Options tool.</p>',
					visibility: {
						enabled: this.$constants.visibility.always,
						logic: {}
					},
					inputs: [],
					buttons: {
						enabled: this.$constants.visibility.always,
						logic: {},
						items: [{
							type: this.$constants.button.type.exit,
							variable: 0,
							text: 'Yes',
							value: 0,
							visibility: {
								enabled: this.$constants.visibility.always,
								logic: {}
							}
						},
						{
							type: this.$constants.button.type.review,
							variable: 0,
							text: 'No',
							value: 0,
							visibility: {
								enabled: this.$constants.visibility.always,
								logic: {}
							}
						}]
					}
				})

				this.$store.commit('session/alerts/current', true)

			}

		},

		onSupplementaryComplete: function() {

			if (this.bridge.trigger === 'print') {

				// Force aid.treatment to Oral bisphosphonates if 1a or 1d selected
				var medicine = this.$store.getters['session/values'][100]

				if (medicine === 1 || medicine === 4) {

					var named = this.$store.getters['logic/variable/named']

					if (named['aid.treatment']) {
						this.$store.commit('session/values/override', { id: named['aid.treatment'], value: 1 })
					}

				}

				this.$store.commit('session/bridge/completed', this.$store.getters['session/bridge/active'].id)
				this.bridge.step = 'print-done'

			}

		},

		onSupplementaryCancel: function() {

			this.bridge.step = null
			this.bridge.trigger = null
			this.$store.commit('session/bridge/reset')

		},

		onBridgeDone: function() {

			this.bridge.step = null
			this.bridge.trigger = null
			this.$store.commit('session/bridge/reset')

		},

		onReferralUsed: function() {

			this.$store.commit('session/bridge/completed', this.$store.getters['session/bridge/active'].id)

		},

		setBridgeMode: function(enabled) {

			var named = this.$store.getters['logic/variable/named']

			if (named['ns.bridgemode']) {
				this.$store.commit('session/values/override', { id: named['ns.bridgemode'], value: enabled ? 1 : 0 })
			}

		},

		onNextClick: function() {

			this.$api.request('track', {
				recommendation: this.$store.getters['session/recommendation'],
				treatment: (this.hasNone) ? 0 : 1,
				login: ''
			})

			var section = this.$_.findWhere(this.$store.getters['data/aid/sections'], { type: 'risk' })
			
			var score =  this.$store.getters['session/values'][section.density.variable]

			if (score === null) {

				this.$store.commit('session/alerts/dynamic', {
					type: this.$constants.alert.type.warning,
					name: 'Error',
					message: '<p>' + section.tscore + '</p>',
					visibility: {
						enabled:  this.$constants.visibility.sometimes,
						logic: {}
					},
					inputs: [11],
					buttons: {
						enabled:  this.$constants.visibility.always,
						logic: {},
						items: [{
							type:  this.$constants.button.type.proceed,
							variable: 0,
							text: 'Next',
							value: 0,
							visibility: {
								enabled:  this.$constants.visibility.sometimes,
								logic: {
									"AND": [
										["v:12","5","9"],
										["v:12","6","-9"]
									]
								}
							}
						},
						{
							type:  this.$constants.button.type.proceed,
							variable: 0,
							text: 'Skip',
							value: 0,
							visibility: {
								enabled:  this.$constants.visibility.always,
								logic: {}
							}
						}]
					}
				})

				this.$store.commit('session/alerts/current', true)

			} else {

				this.$store.dispatch('proceed')

			}

		}
		
	}

}

</script>

<style scoped>

.recommendation {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .recommendation {
	left: 64px;
}

.is-mobile .recommendation {
	left: 0px;
}

.recommendation-content {
	width: 100%;
	padding: 90px;
	max-width: 1200px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-tablet .recommendation-content {
	width: 100%;
}

.is-mobile .recommendation-content {
	width: 100%;
	padding: 80px 15px 85px 15px;
}

.section-exit {
	position: absolute;
	right: 25px;
	top: 20px;
	width: 48px;
	height: 48px;
	cursor: pointer;
	background-image: url(~@/assets/exit.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	z-index: 1000;
}

.is-mobile .section-exit {
	right: 5px;
	top: 5px;
}

.recommendation-saved {
	background-color: #efefef;
	padding: 16px;
	font-size: 14px;
	margin-bottom: 48px;
	line-height: 20px;
	color: #343434;
	font-weight: 500;
	border-radius: 16px;
	margin-top: -32px;
}

.is-mobile .recommendation-saved {
	border-radius: 0px;
	margin-top: 0px;
}

</style>